import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getMaterialBatchData = createApi(`MaterialBatchDataSlice`,"GET");

const MaterialBatchDataSlice = createSlice({
  name: 'MaterialBatchDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMaterialBatchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMaterialBatchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getMaterialBatchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default MaterialBatchDataSlice.reducer;